"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBreakpointDownKey = getBreakpointDownKey;
exports.getBreakpointOnlyKey = getBreakpointOnlyKey;
exports.getBreakpointUpKey = getBreakpointUpKey;
var _utilities = require("../utilities");
function getBreakpointUpKey(breakpoint) {
  return `${breakpoint}Up`;
}
function getBreakpointDownKey(breakpoint) {
  return `${breakpoint}Down`;
}
function getBreakpointOnlyKey(breakpoint) {
  return `only${(0, _utilities.capitalizeFirstWord)(breakpoint)}`;
}